import { getSessionInfo } from '../../utils/craft.js';
import { formatPhone, validateField, validateRequiredFields } from '../../utils/form.js';
import { formCompletedEvent, formStartEvent, formSubmitEvent } from '../../utils/gtm.js';

export default function iotInterestedForm() {
  const form = document.querySelector('#iot-interested-form');
  const successMessage = document.querySelector('.form__success');

  if (!form) return;

  const formContainer = form.closest('.form-container');
  const inputs = form.querySelectorAll('input, textarea');
  const selectInput = form.querySelector('select');
  const dialogEl = form.closest('dialog');
  let firstFocus = false;

  inputs.forEach((element) => {
    element.addEventListener('blur', () => {
      if (element.value === '') return;
      validateField(element);
      if (element.type === 'tel') {
        element.value = formatPhone(element.value);
      }
    });
    element.addEventListener('focus', () => {
      if (!firstFocus) {
        window.pushGTMEvent(formStartEvent(form));
        firstFocus = true;
      }
    });
  });

  selectInput.addEventListener("change", () => {
    validateField(selectInput);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    if (!firstFocus) {
      window.pushGTMEvent(formStartEvent(form));
      firstFocus = true;
    }

    if (typeof grecaptcha === 'undefined') {
      // eslint-disable-next-line no-undef
      grecaptcha = {};
    }

    // eslint-disable-next-line no-undef
    grecaptcha.ready(function () {
      // eslint-disable-next-line no-undef
      grecaptcha.execute(window.recaptchaKey, { action: 'submit' }).then(function (token) {
        getSessionInfo().then((session) => {
          const formData = new FormData(form);

          formContainer.classList.remove('error');
          formContainer.classList.add('submitting');

          formData.append(window.csrfTokenName, session.csrfTokenValue);
          formData.append('token', token);

          if (!validateRequiredFields(form)) {
            formContainer.classList.remove('submitting');
            formContainer.classList.add('error');
            return;
          }

          fetch(form.action, { method: 'POST', body: formData })
            .then(function (response) {
              if (response.status != 200) {
                console.log('response:', response);
                throw response.status;
              } else {
                return response.json();
              }
            })
            .then(function (data) {
              if (data.success) {
                formContainer.classList.add('submitted');
                successMessage.focus();

                if(dialogEl) {
                  dialogEl.addEventListener('close', () => {
                    formContainer.classList.remove('submitted', 'submitting');
                    form.reset();
                  });
                }

                window.pushGTMEvent(formSubmitEvent(form));
                window.pushGTMEvent(formCompletedEvent(form));

              } else {
                formContainer.classList.remove('submitting');
                formContainer.classList.add('error');
              }

              console.log('form Response', data);
            })
            .catch(function (error) {
              console.log('Error: ' + error);
            });
        });
      });
    });
  });
}
